import { createSlice } from "@reduxjs/toolkit";
import { DocumentState } from "@pdfViewer/models";

const initialState: DocumentState = {
  documentName: null,
  documentId: null,
  documentUrl: null,
  isOpenDocumentDialog: false,
};

export const pdfViewerSlice = createSlice({
  name: "pdfViewer",
  initialState,
  reducers: {
    resetState: (state) => {
      state.documentName = initialState.documentName;
      state.documentId = initialState.documentId;
      state.documentUrl = initialState.documentUrl;
      state.isOpenDocumentDialog = initialState.isOpenDocumentDialog;
    },
    openDocumentDialog: (state, action) => {
      state.documentName = action.payload.documentName;
      state.documentId = action.payload.documentId;
      state.documentUrl = action.payload.documentUrl;
      state.isOpenDocumentDialog = true;
    },
    closeDocumentDialog: (state) => {
      state.documentName = initialState.documentName;
      state.documentId = initialState.documentId;
      state.documentUrl = initialState.documentUrl;
      state.isOpenDocumentDialog = false;
    },
  },
});
export const { resetState, openDocumentDialog, closeDocumentDialog } = pdfViewerSlice.actions;
export default pdfViewerSlice.reducer;
